module.exports = __webpack_public_path__ + "static/media/instant_auto_cash.e0e5886d.png";